import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledHealthcareProviderLocationTextViewLink = styled(Link)`
   margin-top: -3px;
`;

StyledHealthcareProviderLocationTextViewLink.displayName = 'StyledHealthcareProviderLocationTextViewLink';
